<template>
  <div class="app-menu">
    <div class="app-menu-inner">
      <div class="menu-item" v-for="item in menuList" :key="item.id">
        <a class="menu-title" :href="getHref(item)">
          {{item.classname}}
          <i class="iconfont icon-down" v-if="Array.isArray(item.subMenus) && item.subMenus.length"></i>
        </a>
        <div class="sub-menu-container" v-if="Array.isArray(item.subMenus) && item.subMenus.length">
          <a
            class="sub-menu-item"
            :href="getHref(subItem)"
            v-for="subItem in item.subMenus"
            :key="subItem.id"
          >{{subItem.classname}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHref } from '@/utils';
export default {
  props: {
    menuList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  methods: {
    getHref,
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variable.scss';
.app-menu {
  z-index: 999;
  height: $menu_height;
  position: relative;
  background: #262626;
  // border-bottom: 1px solid #eeeeee;
  .app-menu-inner {
    font: normal 16px/59px "microsoft yahei";
    position: absolute;
    display: flex;
    width: $container_width;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    // font-size: 14px;
    .menu-item {
      height: 100%;
      flex: 1;
      text-align: center;
      // font-weight: bold;
      line-height: $menu_height;
      box-sizing: border-box;
      color: #fff;
      a {
        color: #fff;
      }
      i {
        color: #aaa;
        font-size: 12px;
        margin-left: 5px;
      }
      .menu-title {
        display: block;
      }
      cursor: pointer;
      .sub-menu-container {
        width: 100%;
        display: none;
        background: #262626;
      }
      &:hover {
        border-bottom: 4px solid #007012;
        color: $theme_color;
        .sub-menu-container {
          display: block;
          .sub-menu-item {
            display: block;
            &:hover {
              background: #373737;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Menu.vue